import React, { Component } from "react";
import InfoBlock from "../presentational/InfoBlock";
import Documents from "../presentational/Documents";
import Investors from "../presentational/Investors";
import ListOfYears from "../presentational/ListOfYears";
import AsideMenu from "../presentational/AsideMenu";
import { textToLink } from "../functions/textToLink";
import { formatNameToShow } from "../functions/formatNameToShow";
import { downloadUrl } from "../config";

class InvestorsContainer extends Component {
  moduleName = textToLink("за инвеститори");

  // това са трите главни секции, които искаха да се направят
  // понеже няма апи, което да връща информацията, повечето неща
  // са описани в кода
  sections = [
    "Финансови отчети",
    "Проспект",
    "Общо събрание на акционерите",
    "Вътрешна информация",
    "Доклади за възнагражденията"
  ].map(en => ({ text: en, ttl: textToLink(en) }));

  shouldComponentUpdate(prevProps) {
    return (
      prevProps.match.params.section !== this.props.match.params.section ||
      prevProps.match.params.year !== this.props.match.params.year
    );
  }

  // връща списък от годините, които трябва да се визуализират
  // в лявата част на сайта
  getListOfYears = (ttl, section, year) =>
    Object.keys(window.documentsList[ttl])
      .sort((a, b) => b - a)
      .map(forYear => ({
        to: `/${this.moduleName}/${ttl}/${forYear}`,
        forYear,
        active: ttl === section && forYear === year
      }));

  render() {
    console.log(window);
    const { documentsList } = window;
    let { section, year } = this.props.match.params;

    // ако нямаме валидна стойност за секция, вземаме първата по подразбиране
    if (documentsList[section] === undefined) {
      section = this.sections[0].ttl;
    }

    // за година по подразбиране вземаме най-голямата налична в секцията,
    // само ако не се подава в url параметрите
    if (documentsList[section][year] === undefined) {
      year = Math.max(...Object.keys(documentsList[section]));
    }

    // пакетираме списъка от документи, които трябва да се покажат
    const documents = documentsList[section][year].map(document => ({
      href: `${downloadUrl}${section}/${year}/${document}`,
      text: formatNameToShow(document)
    }));

    // текст, който да се показва като заглавие
    const { text } = this.sections.find(en => en.ttl === section);

    // списък от годините
    const left = (
      <AsideMenu>
        {this.sections.map(({ text, ttl }) => (
          <ListOfYears key={text} text={text} forYears={this.getListOfYears(ttl, section, year)} />
        ))}
      </AsideMenu>
    );

    // списък от документи
    const right = <Documents title={`${text} ${year}`} documents={documents} />;

    return (
      <InfoBlock dynamic>
        <Investors left={left} right={right} />
      </InfoBlock>
    );
  }
}

export default InvestorsContainer;



// WEBPACK FOOTER //
// ./src/containers/Investors.js